import { ChangeDetectionStrategy, Component, Injector, Input, OnInit } from '@angular/core';
import { take } from 'rxjs/operators';
import { WidgetBaseComponent } from '../../widgetBase';

/**
 * IncomeAnalysis2 Widget
 */
@Component({
  selector: 'income-analysis2-widget',
  templateUrl: './income-analysis2-widget.component.html',
  styleUrls: ['../../common/css/general.scss', './income-analysis2-widget.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush
})
export class IncomeAnalysis2WidgetComponent extends WidgetBaseComponent implements OnInit {

  /**
   * Widget Guid
   */
  @Input() widgetGuid: string;

  /**
   * Are charts ready to be displayed?
   */
  chartsReady = false;

  /**
   * Chart ERV Analysis data
   */
  ervAnalysisData: any[] = [];

  /**
   * Chart categories
   */
  categories: any[];

  /**
   * Chart ExpiryRisk series
   */
  seriesExpiryRisk: any[];

  /**
   * Chart colors
   */
  colors: string[] = ['#d4d5d6', '#9870a6', '#616468', '#999a9d', '#d4d0df', '#836b6e', '#e30614'];

  /**
  * Constructor
  */
  constructor(injector: Injector) {
    super(injector, 'incomeAnalysis2', true);
  }

  /**
   * Widget's text area options (if used)
   */
  textAreaOptions: any = null;

  /**
   * Initializes the component
   */
  ngOnInit() {
    // will call registerEvents and onInitialized when config (this.widgetConfig and this.page) is ready

    this.initWidgetConfig();
    this.widgetResized();
  }

  /**
   * Called by base class to let widget register to various app events (like saving, loading, resizing etc)
   */
  registerEvents(): void {
    this.useDefaultServiceSaveChangesHandler("incomeAnalysis2", this.provideSaveObject.bind(this));
  }

  /**
   * Called by base class to inform widget that it is initialized
   * Mostly used to define where widget data should be loaded from
   */
  onInitialized(): void {
    this.mockupData$ = this.widgetService.loadMockup('incomeAnalysis2').pipe(take(1));

    this.widgetData$ = this.mockup ?
      this.mockupData$
      : this.widgetService.load('incomeAnalysis2', this.getReport()).pipe();
  }

  /**
   * Called by base class to let widget preprocess loaded data if required
   */
  protected preprocessLoadedData(data) {
    this.reportDesignerTranslator.ready('incomeAnalysis2').then(() => {
      this.seriesExpiryRisk = [
        {
          name: this.reportDesignerTranslator.getString('incomeAnalysis2.labelExpiryRisk'),
          color: '#636468',
          data: data.years.map((entry) => entry.expiryRisk)
        }
      ];

      data.keyTenants.forEach((tenant, i) => {
        this.ervAnalysisData.push({
          label: tenant.tenantLeaseName,
          color: this.colors[i],
          value: tenant.tenantContractedRent
        });
      });

      this.categories = data.years.map((entry) => entry.dcfYear + new Date(entry.dcfStartDate).getFullYear());

      this.chartsReady = true;
      this.ref.markForCheck();
    });

    return data;
  }

  /**
   * Called by base class in save process. Widget should return object to be saved
   */
  async provideSaveObject(): Promise<any> {
    return this.widgetData;
  }

  /**
   * Called by base class to inform widget about save action result
   * @param _success {boolean} The result of save action
   * @param _err {any} The error object, if save action failed
   */
  saveCompleted(_success: boolean, _err: any = null): void {
    //do something if error
  }

}
